import { navigate } from 'gatsby-link';
import React from 'react';
import clsx from 'clsx';
import CategoriesData from '../../atoms/new-glu-client-pages/data';
import useIsMobile from '../../../../hooks/mobile';

// eslint-disable-next-line react/prop-types
const StickyGluHeaderCategories = ({ isScrolled }) => {
	function getMarginBottom(scrolled) {
		if (!scrolled) return '0px';
		return window.innerWidth <= 768 ? '-10px' : '-10px';
	}
	function getMarginTop(scrolled) {
		if (!scrolled) return '0px';
		return window.innerWidth <= 1536 ? '-20px' : '-32px';
	}
	function gap(scrolled) {
		if (!scrolled) return '10px';
		return window.innerWidth <= 768 ? '0px' : '30px';
	}
	const Component = 'div';
	const isMobile = useIsMobile();
	const hrTitle = isMobile ? 'HR' : 'HR & Employment Law';
	const hsTitle = isMobile ? 'H & S' : 'Health & Safety';
	const generateTitle = (title) => {
		switch (title) {
			case 'HR':
				return hrTitle;
			case 'H & S':
				return hsTitle;
			default:
				return title;
		}
	};
	return (
		<div
			className={clsx(
				'w-full max-m-w-screen mx-auto sticky  z-50',
				isScrolled ? ' shadow-lg   mb-2' : 'shadow-none'
			)}
			style={{
				// position: 'relative',
				// zIndex: 50,
				boxShadow: isScrolled
					? '0px 4px 6px rgba(0, 0, 0, 0.1)'
					: 'none',
			}}
		>
			<div
				className={clsx(
					'gluxs:overflow-x-scroll carousel-hide-scrollbar  w-full flex lg:gap-x-10 md:gap-x-5 gap-x-2 md:mt-0 -mt-5 pb-2 md:justify-center justify-start snap-mandatory snap-x'
				)}
			>
				{CategoriesData.map((category) => (
					<div
						key={category.title}
						className="flex gap-2 text-center items-center justify-center glu2xl:text-center flex-col glu2xl:gap-5"
					>
						<Component
							className="cursor-pointer p-2 gap-2 glu-cards flex flex-col grow items-center"
							role="button"
							tabIndex="0"
							onClick={() => navigate(category.link)}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									navigate(category.link);
								}
							}}
						>
							<div
								className="flex items-center  justify-center transition-all duration-300 w-20 h-20 gluxs:w-16 gluxs:h-20 glu2xl:w-[120px] glu2xl:h-[150px]"
								style={{
									transform: isScrolled
										? 'scale(0.6)'
										: 'scale(1)',
									transition: 'all 0.3s ease-in-out',
									marginBottom: getMarginBottom(isScrolled),
									marginTop: getMarginTop(isScrolled),
									gap: gap(isScrolled),
								}}
							>
								<img
									src={category.image}
									alt="Category Icon"
									className="object-contain object-center"
									style={{
										width: '100%',
										height: '100%',
									}}
								/>
							</div>
							<div>
								<p
									className="text-[11px]  md:text-[13px]  text-nowrap"
									style={{
										// marginTop: isScrolled
										// 	? '-20px'
										// 	: '0px',
										marginTop: getMarginTop(isScrolled),
										marginBottom:
											getMarginBottom(isScrolled),
										transform: isScrolled
											? 'scale(1.2)'
											: 'scale(1.2)',
										transition: 'all 0.3s ease-in-out',
									}}
								>
									{generateTitle(category.title)}
								</p>
							</div>
						</Component>
					</div>
				))}
			</div>
		</div>
	);
};

export default StickyGluHeaderCategories;
